import moment from "moment";
import DatePickerComponent from "../../../../components/date-picker/date-picker.component";
import paginationComponent from "../../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import { formats as FORMATS, codeMasterType } from "../../../../config/constants";
import loginModel from "../../../../models/login.model";
import SMSLogModel from "../../../../models/sms-log/sms-log.model";
import ViewBase from "../../../view-base.view";

/**
 * SMS Log
 *
 *
 * @author cmc.kmduc1(Henry)
 */

export default function SMSLogSavinaView() {
  ViewBase.call(this)

  const DEFAULT_FILTERS = Object.freeze({
    fromDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    toDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    messageType: '',
    sites: [],
    division: '',
    replyMessageContent: '',
    typeOfMobileNumber: '',
    mobileNumber: '',
    successStatus: '',
  })

  const DEFAULT_PAGINATION = Object.freeze({
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  })

  let filters = structuredClone(DEFAULT_FILTERS)
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let currentFilters = structuredClone(DEFAULT_FILTERS);

  let messageTypes = [];
  let divisions = [];
  let successStatus = [];

  let typeOfMobileNumbers = [
    { code: '1', name: this.getText('LT00001100', 'Sender’s Mobile') },
    { code: '2', name: this.getText('LT00001101', 'Recipient’s Mobile') }
  ]

  let tableData = [];

  const getMessageTypes = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogMessageType, params)
      .then(result => { messageTypes = result })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getDivisions = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogDivisionType, params)
      .then(result => {
        divisions = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getSMSLogStatus = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    SMSLogModel.getCodeMasterByCategory(codeMasterType.smsLogStatus, params)
      .then(result => { successStatus = result })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getSMSLog = () => {
    this.showLoading();

    const body = {
      fromDate: currentFilters.fromDate,
      toDate: currentFilters.toDate,
      siteIds: currentFilters.sites.map(site => site.siteId),
      division: currentFilters.division,
      status: currentFilters.successStatus,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      recipient: currentFilters.mobileNumber,
      messageType: currentFilters.messageType,
      searchText: currentFilters.replyMessageContent,
      condition: currentFilters.typeOfMobileNumber,
      senderNo: ""
    }

    SMSLogModel.getSMSLog(body)
      .then(result => {
        tableData = result.data
        pagination.pageIndex = result.pageIndex
        pagination.pageSize = result.pageSize
        pagination.totalItems = result.total
      })
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  const handleSearchClick = () => {
    currentFilters = structuredClone(filters)
    pagination.pageIndex = 1

    getSMSLog()
  }

  const handleClear = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  }

  const handlePageIndexChange = (pageIndex) => {
    pagination.pageIndex = pageIndex
    getSMSLog()
  }

  const handlePageSizeChange = (pageIndex, pageSize) => {
    pagination.pageSize = pageSize
    pagination.pageIndex = pageIndex
    getSMSLog()
  }

  const handlePeriodChange = (e) => {
    filters.fromDate = moment(e.detail.start).format(FORMATS.ISO_DATE_FORMAT);
    filters.toDate = moment(e.detail.end).format(FORMATS.ISO_DATE_FORMAT);
  }

  const handleMessageTypeChange = (messageType) => {
    filters.messageType = messageType;
  }

  const handleSiteChange = (sites) => {
    filters.sites = sites;
  }

  const handleReplyMessageContentChange = (e) => {
    filters.replyMessageContent = e.target.value;
  }

  const handleMobileChange = (typeOfMobileNumber) => {
    filters.typeOfMobileNumber = typeOfMobileNumber;
  }

  const handleSuccessStatusChange = (successStatus) => {
    filters.successStatus = successStatus;
  }

  const handleDivisionChange = (division) => {
    filters.division = division
  }

  const handleMobileNumberChange = (e) => {
    filters.mobileNumber = e.target.value
  }

  const handleExcelDownloadClick = () => {
    this.showLoading();

    const body = {
      fromDate: currentFilters.fromDate,
      toDate: currentFilters.toDate,
      countryCode: loginModel.credentials.country,
      status: currentFilters.successStatus,
      recipient: currentFilters.mobileNumber,
      messageType: currentFilters.messageType,
      searchText: currentFilters.replyMessageContent,
      channel: currentFilters.sites.map(site => site.siteId).join('^'),
      condition: currentFilters.typeOfMobileNumber,
      senderNo: '',
      division: currentFilters.division,
    }

    SMSLogModel.commonExcelExport(body, `smsLog_${moment().format('YYYYMMDDHHmm')}`)
      .catch(error => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading()
      });
  }

  return {
    oninit: () => {
      getMessageTypes()
      getDivisions()
      getSMSLogStatus()
      getSMSLog()
    },

    view: () => {
      return [
        /* FILTER TOGGLE */
        m('.d-flex.justify-content-end.mb-2',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
        ),

        /* SEARCH */
        m("#search-section.collapse.show",
          m('.card.mb-3',
            m(".card-body",
              m(".row.g-2",
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m("label.form-label[for=period]",
                    this.getText("LT00000150", "Period")
                  ),
                  m(DatePickerComponent, {
                    id: 'period',
                    class: 'form-control',
                    isRange: true,
                    minDays: 1,
                    dateStart: filters?.fromDate,
                    dateEnd: filters?.toDate,
                    onselect: handlePeriodChange
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="messageType"]',
                    this.getText("LT00001048", "Message Type")
                  ),
                  m(SingleSelectComponent, {
                    id: "messageType",
                    items: messageTypes,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.messageType,
                    onSelect: handleMessageTypeChange
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="sites"]', this.getText("LT00000071", "Site")),
                  m(SelectSiteSearchInputComponent, {
                    id: 'sites',
                    multiple: true,
                    selectedItems: filters.sites,
                    onSelect: handleSiteChange,
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="division"]',
                    this.getText("LT00000233", "Division")
                  ),
                  m(SingleSelectComponent, {
                    id: "division",
                    items: divisions,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.division,
                    onSelect: handleDivisionChange
                  })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="replyMessageContent"]', this.getText("LT00000908", "IMEI")),
                  m('input.form-control.form-control-bg',
                    {
                      id: 'replyMessageContent',
                      onchange: handleReplyMessageContentChange,
                      placeholder: this.getText("LT00000908", "IMEI"),
                      value: filters.replyMessageContent
                    })
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="mobileNumber"]',
                    this.getText("LT00000784", "Mobile")
                  ),
                  m('.d-flex.gap-1',
                    m(SingleSelectComponent, {
                      id: "typeOfMobileNumber",
                      items: typeOfMobileNumbers,
                      keyOnly: true,
                      allowEmpty: true,
                      filterable: false,
                      selectedItem: filters.typeOfMobileNumber,
                      onSelect: handleMobileChange
                    }),
                    m('input.form-control.form-control-bg',
                      {
                        id: 'mobileNumber',
                        value: filters.mobileNumber,
                        onchange: handleMobileNumberChange
                      })
                  )
                ),
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative",
                  m('label.form-label[for="successStatus"]',
                    this.getText("LT00001058", "Success Status")
                  ),
                  m(SingleSelectComponent, {
                    id: "successStatus",
                    items: successStatus,
                    keyOnly: true,
                    allowEmpty: true,
                    filterable: false,
                    selectedItem: filters.successStatus,
                    onSelect: handleSuccessStatusChange
                  })
                ),
                m(".col-12.d-flex.justify-content-end.gap-2",
                  m("button.btn.btn-primary",
                    {
                      type: "submit",
                      onclick: handleSearchClick
                    },
                    this.getText("LT00000001", "Search")
                  ),
                  m("button.btn.btn-white",
                    {
                      type: "button",
                      onclick: handleClear
                    },
                    this.getText("LT00000031", "Clear")
                  )
                )
              )
            )
          )
        ),

        /* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12.d-flex.justify-content-end",
                m('a.btn.btn-primary', { onclick: handleExcelDownloadClick },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                )
              ),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover",
                    m("thead",
                      m("tr.align-middle.text-center",
                        m('th[scope="col"]',
                          this.getText("LT00001057", "Send Date")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00000038", "Sender")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001053", "Received Message")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001055", "Reply Message")
                        ),
                        m('th[scope="col"]',
                          this.getText("LT00001054", "Recipient")
                        )
                      )
                    ),
                    m("tbody",
                      tableData.length == 0 &&
                      m("tr.align-middle",
                        m("td[colSpan=13]",
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      tableData.length > 0 &&
                      tableData.map((data) =>
                        m("tr.align-middle",
                          m("td", m("span.cursor-text", data.sendDate)),
                          m("td", m("span.cursor-text", data.senderID)),
                          m("td", m("span.cursor-text", data.receivedMessage)),
                          m("td", { style: "white-space: initial" }, m("span.cursor-text", data.replyMessage)),
                          m("td", m("span.cursor-text", data.recipient)),
                        )
                      )
                    )
                  )
                ),
              ),
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: handlePageIndexChange,
                  onPageSizeChanged: handlePageSizeChange
                })
              )
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
